module.exports = __webpack_public_path__ + "static/media/Library_0.e5976e39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/library/Library_0.png
// module id = 1287
// module chunks = 3